import TripDetailsContainer from './TripDetailsContainer';

export default TripDetailsContainer;
